/* file description */

import useMetaStore from '@/store/useMetaStore';
import React from 'react';
import * as ICONS from '@ant-design/icons';
import styles from './index.module.less';
import { Button, Tooltip } from 'antd';
import { EsConfigType } from '@/asset/AssetTask/templates/Cascade/effect';
import { useResultEventConfig } from './useResultEventConfig';

interface EventCentrePropsType {
  rowIndex: any;
  value: string;
  onChange: (v: any) => void;
  id: string;
  children: any;
  field: any;
  config: Record<string, any>;
}

export const EditRender: React.FC<EventCentrePropsType> = (props) => {
  const { events, emitEvent, pageType, pageConfig } = useMetaStore();
  const { field, children, rowIndex, config, ...otherProps } = props;

  const { resultEventConfig } = useResultEventConfig(field);

  const onChange = (value) => {
    props.onChange(value);
    emitEvent && emitEvent({ value: value?.target?.value || value, moduleName: field?.moduleName, fieldName: field?.name, rowIndex, touchConfig: 'change' });
  };


  const clickFun = () => {
    emitEvent && emitEvent({ value: '', eventsIds: [resultEventConfig?.code], rowIndex, touchConfig: 'click' });
  };

  if (React.isValidElement(props.children) && config.from !== 'search') {
    if (resultEventConfig) {
      return (
        <div className={styles.linkIcon}>
          {React.cloneElement(props.children as any, { ...otherProps, value: props.value, id: props.id, onChange, style: { flexGrow: 1 } })}
          <Tooltip title={resultEventConfig?.tooltipText || '点击查看'}>
            <Button
              style={{ borderLeft: 'unset' }}
              icon={React.createElement(ICONS[resultEventConfig?.openIcon || 'LinkOutlined'])}
              onClick={clickFun}
            />
          </Tooltip>
        </div>
      );
    }
    return React.cloneElement(props.children as any, { ...otherProps, value: props.value, id: props.id, onChange });
  }
  return React.cloneElement(props.children as any, { ...otherProps, value: props.value, id: props.id, onChange });
};

